import instance from "../axios";
import { notifySuccess,notifyError,notifyWarning,notifyInfo } from "./CustomNotifications";

export{
    notifySuccess,
    notifyError,
    notifyWarning,
    notifyInfo
}

export const sendLocation = async ({ device, form, userId }) => {
  const payload = {
    location: {
      speed: device?.speed || 0,
      id: device?.uniqueId || 0,
      bearing: device?.bearing || 0,
      lon: form?.longitude || form?.Longitude || 0,
      panicButton: false,
      batt: device?.batt ?? -1,
      timestamp: new Date().toISOString(),
      networkType: "wifi",
      lat: form?.latitude || form?.Latitude || 0,
      signalStrength: "",
      cellularType: "",
      accuracy: device?.accuracy ?? 5,
      altitude: device?.altitude ?? 0,
      statusModificationRemarks: form?.remarks || "",
      statusModifiedByUserId: userId,
    },
  };

  try {
  const response = await instance.post("/api/positions/asset/loc", payload, {
    singleReturn: true,
    // headers: {
    //   Accept: "*/*",
    //   "Content-Type": "application/json; charset=utf-8",
    //   "Accept-Language": "en-GB,en;q=0.9",
    // },
  });
  return { success: true, status: response.status };
} catch (err) {
    console.error("API Request Error:", err);
  throw err;
}

};